<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/pppclubbeddeath005#toc">Epigraph</a></p>
<p class="pc"><b>Since Death on All</b></p>
<p class="epf">Since death on all lays his impartial hand</p>
<p class="ep">And all resign at his command,</p>
<p class="ep">The stoic too, as well as I,</p>
<p class="ep">With all his gravity must die;</p>
<p class="ep">Let’s wisely manage this last span,</p>
<p class="ep">The momentary life of man;</p>
<p class="ep">And still in pleasure’s circle move,</p>
<p class="ep">Giving our days to friends, and all our nights to love.</p>
<p class="ep">Then while we are here let’s thus perfectly live</p>
<p class="ep">And taste all the pleasures that nature can give;</p>
<p class="ep">Fresh heat when life’s fading our wine will inspire,</p>
<p class="ep">And fill all our veins with a nobler fire.</p>
<p class="ep">When we’re sapless, old and impotent,</p>
<p class="ep">Then we shall grieve for youth misspent;</p>
<p class="ep">Wine and women only can</p>
<p class="ep">Cherish the heavy heart of man.</p>
<p class="ep">Let’s drink on till our blood o’erflows</p>
<p class="ep">Its channels, and luxuriant grows,</p>
<p class="ep">Then when our whores have drained each vein</p>
<p class="ep">And the thin mass fresh spirits crave, let’s drink again.</p>
<p class="ep">Then while we are here let’s thus perfectly live</p>
<p class="ep">And taste all the pleasures that nature can give;</p>
<p class="ep">Fresh heat when life’s fading our wine will inspire,</p>
<p class="epl">And fill all our veins with a nobler fire.</p>
<p class="ept">—John Wilmot, Earl of Rochester</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppclubbeddeath006.vue?440078c1